import * as React from 'react';
import type { SVGProps } from 'react';

const SvgArticlesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={20} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M16 0H3C1.794 0 0 .799 0 3v14c0 2.201 1.794 3 3 3h15v-2H3.012C2.55 17.988 2 17.805 2 17c0-.101.009-.191.024-.273.112-.575.583-.717.987-.727H17c.018 0 .031-.009.049-.01H18V2c0-1.103-.897-2-2-2Zm0 14H2V3c0-.806.55-.988 1-1h7v7l2-1 2 1V2h2v12Z"
    />
  </svg>
);
export default SvgArticlesIcon;
